/**
 * Video Facade
 *
 * Two patterns:
 *  1. Click-to-play (.video-block__facade) — Vimeo player loads only when the
 *     user opts in. Avoids the ~150 KB Vimeo JS + 3rd-party cookies + the
 *     deprecated unload listeners up-front.
 *  2. Hero autoload (.video-banner__facade) — injected on DOMContentLoaded so
 *     the background video paints as early as possible.
 */

import { ready, $$ } from "./utils.js";

ready(() => {
  const facades = $$(".video-block__facade");
  if (facades.length > 0) {
    facades.forEach((facade) => {
      facade.addEventListener("click", handleClick, { once: true });
    });
  }

  loadHeroVideos();
});

function handleClick(event) {
  const facade = event.currentTarget;
  const src = facade.getAttribute("data-vimeo-src");
  if (!src) return;

  const iframe = document.createElement("iframe");
  iframe.src = src;
  iframe.setAttribute("frameborder", "0");
  iframe.setAttribute("allow", "autoplay; fullscreen; picture-in-picture");
  iframe.setAttribute("referrerpolicy", "strict-origin-when-cross-origin");
  iframe.setAttribute("title", facade.getAttribute("aria-label") || "Video");

  facade.replaceWith(iframe);
}

function loadHeroVideos() {
  const facades = document.querySelectorAll(".video-banner__facade");
  facades.forEach(injectHeroPlayer);
}

function injectHeroPlayer(facade) {
  const type = facade.dataset.videoType;
  let el;

  if (type === "mp4") {
    const mp4Url = facade.dataset.mp4Url;
    if (!mp4Url) return;
    el = document.createElement("video");
    el.autoplay = true;
    el.muted = true;
    el.loop = true;
    el.playsInline = true;
    const source = document.createElement("source");
    source.src = mp4Url;
    source.type = "video/mp4";
    el.appendChild(source);
  } else {
    const src = facade.dataset.videoSrc;
    if (!src) return;
    el = document.createElement("iframe");
    el.src = src;
    el.setAttribute("frameborder", "0");
    el.setAttribute("referrerpolicy", "strict-origin-when-cross-origin");
    el.setAttribute("allow", "autoplay; fullscreen");
    el.setAttribute("aria-hidden", "true");
    el.setAttribute("title", "");
    el.setAttribute("tabindex", "-1");
  }

  facade.replaceWith(el);
}
